import {
    MollieComponentTypeKeys,
    MollieEventPayload
} from "@omni/types/packages/mollie.types";
import { cn } from "@omni/utils/styles";
import { useEffect, useState } from "react";

import { useMollie } from "../mollie.provider";

type SecureInputFieldProps = {
    name: MollieComponentTypeKeys;
    onChange?: (e: MollieEventPayload) => void;
    onBlur?: (e: MollieEventPayload) => void;
    onFocus?: (e: MollieEventPayload) => void;
    isInvalid: boolean;
    isValid: boolean;
};

const SecureInputField = ({
    name,
    onChange,
    onBlur,
    onFocus,
    isInvalid,
    isValid
}: SecureInputFieldProps) => {
    const { mollie } = useMollie();
    const [isFocused, setIsFocus] = useState(false);

    const onInnerFocus = (e: MollieEventPayload) => {
        setIsFocus(true);
        onFocus?.(e);
    };

    const onInnerBlur = (e: MollieEventPayload) => {
        setIsFocus(false);
        onBlur?.(e);
    };

    const onInnerChange = (e: MollieEventPayload) => {
        onChange?.(e);
    };

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (mollie) {
            const cardNumber = mollie.createComponent(name);
            cardNumber.mount(`#${name}`);

            cardNumber.addEventListener("change", onInnerChange);
            cardNumber.addEventListener("blur", onInnerBlur);
            cardNumber.addEventListener("focus", onInnerFocus);

            return function cleanUp() {
                // setIsFocus(false)
                cardNumber.unmount();
            };
        }
    }, [mollie]);

    return (
        <div
            id={name}
            className={cn(
                "form-control",
                isFocused && "form-control--focus",
                isInvalid && "is-invalid",
                isValid && "is-valid"
            )}
        ></div>
    );
};

export { SecureInputField };
